import React from 'react';
import { C, radius, shadow } from '../styles';
import { useAuth } from '../context/AuthContext';
import { useJobs } from '../context/JobsContext';

const NAV = [
  // { key: 'query',   label: 'Query DB',    icon: 'db'     },
  { key: 'run',     label: 'Upload File', icon: 'upload' },
  { key: 'history', label: 'History',     icon: 'clock'  },
];

function NavIcon({ name, color }) {
  const stroke = color || 'currentColor';
  const common = { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none',
                   stroke, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (name === 'db') return (
    <svg {...common}>
      <ellipse cx="12" cy="5" rx="9" ry="3"/>
      <path d="M3 5v6c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
      <path d="M3 11v6c0 1.66 4.03 3 9 3s9-1.34 9-3v-6"/>
    </svg>
  );
  if (name === 'upload') return (
    <svg {...common}>
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  );
  if (name === 'clock') return (
    <svg {...common}>
      <circle cx="12" cy="12" r="9"/>
      <polyline points="12 7 12 12 15 14"/>
    </svg>
  );
  return null;
}

export default function Topbar({ activePage, setPage }) {
  const { user, logout } = useAuth();
  const { jobList } = useJobs();
  const activeCount = jobList.filter(j => j.status === 'processing').length;

  const role = (user?.role || '').toLowerCase();
  const initials = (user?.name || user?.username || '?')
    .split(/\s+/).map(s => s[0]).join('').slice(0, 2).toUpperCase();

  return (
    <header style={{
      height: 60,
      background: 'rgba(255,255,255,0.82)',
      backdropFilter: 'blur(14px)',
      WebkitBackdropFilter: 'blur(14px)',
      borderBottom: `1px solid ${C.border2}`,
      display: 'flex', alignItems: 'center',
      padding: '0 24px', gap: 10, flexShrink: 0,
      position: 'sticky', top: 0, zIndex: 100,
      boxShadow: shadow.xs,
    }}>
      {/* Logo */}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginRight:20,
                    paddingRight:20, borderRight:`1px solid ${C.border2}`, height:'100%' }}>
        <img src="/finkraft-logo-light.png" alt="Finkraft.ai"
             style={{ height:22, width:'auto' }}/>
        <span style={{
          fontFamily:'Inter,sans-serif', fontWeight:600, fontSize:11,
          color: C.muted, letterSpacing:'.08em', textTransform:'uppercase',
          borderLeft:`1px solid ${C.border2}`, paddingLeft:12,
        }}>
          GST Platform
        </span>
      </div>

      {/* Nav */}
      <nav style={{ display:'flex', gap:4 }}>
        {NAV.map(({ key, label, icon }) => {
          const active = activePage === key;
          return (
            <button key={key} onClick={() => setPage(key)} style={{
              display:'flex', alignItems:'center', gap:7,
              background: active
                ? `linear-gradient(135deg, ${C.accent} 0%, ${C.teal} 100%)`
                : 'transparent',
              border: 'none',
              borderRadius: radius.md,
              padding: '7px 14px', cursor: 'pointer',
              fontFamily: 'Inter,sans-serif', fontSize: 13,
              fontWeight: active ? 600 : 500,
              color: active ? '#fff' : C.textSoft,
              transition: 'all .15s',
              boxShadow: active ? '0 3px 8px rgba(8,145,178,0.22)' : 'none',
            }}
            onMouseEnter={e => { if (!active) e.currentTarget.style.background = C.surface3; }}
            onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
            >
              <NavIcon name={icon} />
              {label}
            </button>
          );
        })}
      </nav>

      {/* Active jobs pill */}
      {activeCount > 0 && (
        <div style={{
          display:'flex', alignItems:'center', gap:6,
          background: C.tealBg, border:`1px solid ${C.teal}55`,
          borderRadius:20, padding:'4px 11px', marginLeft:6,
        }}>
          <span style={{ width:7, height:7, borderRadius:'50%', background: C.teal,
                         animation:'pulse 1.2s infinite', flexShrink:0,
                         boxShadow:`0 0 0 3px ${C.tealBg}` }} />
          <span style={{ fontSize:11.5, color: C.accent2, fontWeight:600 }}>
            {activeCount} running
          </span>
        </div>
      )}

      {/* Right */}
      <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:10 }}>
        {/* Avatar + user info */}
        <div style={{ display:'flex', alignItems:'center', gap:10,
                      background: C.surface2, border:`1px solid ${C.border2}`,
                      borderRadius:20, padding:'3px 12px 3px 3px' }}>
          <div style={{
            width:28, height:28, borderRadius:'50%',
            background:`linear-gradient(135deg, ${C.accent} 0%, ${C.teal} 100%)`,
            display:'grid', placeItems:'center', color:'#fff',
            fontSize:11, fontWeight:700, fontFamily:'Inter,sans-serif',
            flexShrink:0,
          }}>{initials}</div>
          <div style={{ display:'flex', flexDirection:'column', lineHeight:1.15 }}>
            <span style={{ fontSize:12, color: C.text, fontWeight:600 }}>
              {user?.name || user?.username}
            </span>
            <span style={{ fontSize:10, color: C.muted, textTransform:'capitalize',
                           letterSpacing:'.04em' }}>{role}</span>
          </div>
        </div>
        <button onClick={logout} style={{
          background: C.surface, border:`1px solid ${C.border2}`,
          borderRadius: radius.sm, padding:'6px 12px', color: C.muted,
          fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:'Inter,sans-serif',
          transition:'all .15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = C.danger; e.currentTarget.style.color = C.danger; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = C.border2; e.currentTarget.style.color = C.muted; }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}